import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import { Scrollbars } from 'react-custom-scrollbars';

import MaterialNotFound from 'components/MaterialNotFound';
import Loader from 'components/Loader';
import MediaItem from 'admin-moderator/components/MediaItem';

import Files from './Files';
import Materials from './Materials';
import LinkToMaterial from './LinkToMaterial';

const UserMaterials = props => (
  <Materials>
    <Scrollbars
      autoHide
      autoHeight
      autoHeightMax="calc(100vh - 340px)"
    >
      <Files>
        {props.materials.map(material => (
          <LinkToMaterial
            to={`/materials/${material.id}`}
            key={material.id}
            data-accepted={material.status === 'accepted'}
          >
            <MediaItem
              cover={material.file && material.file.type === 'video'
                ? material.file && material.file.cover && material.file.cover.url
                : material.file && material.file.url
              }
              mediaType={material.file && material.file.type}
              size="small"
            />
          </LinkToMaterial>
        ))}
      </Files>

      {props.hasMore && !props.error && !props.loading && (
        <Waypoint onEnter={props.onWaypointEnter} />
      )}
    </Scrollbars>

    {!props.loading && props.materials.length === 0 && <MaterialNotFound />}

    {props.loading && <Loader />}

    {props.error && <div>Что-то пошло не так</div>}
  </Materials>
);

UserMaterials.propTypes = {
  materials: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      status: PropTypes.oneOf(['created', 'approved', 'rejected']),
      file: PropTypes.shape({
        type: PropTypes.oneOf(['video', 'image']),
        cover: PropTypes.shape({ url: PropTypes.string }),
        url: PropTypes.string,
      }),
    })
  ),
  loading: PropTypes.bool,
  error: PropTypes.bool,
  hasMore: PropTypes.bool,
  onWaypointEnter: PropTypes.func,
};

UserMaterials.defaultProps = {
  materials: [],
  loading: false,
  error: false,
  hasMore: false,
  onWaypointEnter: () => {},
};

export default UserMaterials;
